
import { BiRocket, BiSearchAlt, BiShield } from "react-icons/bi";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import "./CTAPage.css";
import React, { useEffect } from "react";
import { useState } from "react";

const CTAPage = ({ isDarkMode}) => {
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      serviceType: "",
      customService: "",
      message: "",
      budget: "",
      customBudget: "",
      deadline: "",
    });
    
    const [consultationData, setConsultationData] = useState({
      name: '',
      email: '',
      phone: '',
      company: '',
      website: '',
      serviceType: '',
      customService: '',
      projectDescription: '',
      problemStatement: '',
      existingSystem: '',
      communicationMethod: '',
      preferredDate: '',
      preferredTime: '',
      referralSource: '',
      additionalInfo: '',
    });
    
    
      const [statusMessage, setStatusMessage] = useState('');
      const [consultationStatusMessage, setConsultationStatusMessage] = useState('');
      const [showQuotePopup, setShowQuotePopup] = useState(false);
      const [showConsultationPopup, setShowConsultationPopup] = useState(false);
    
  
      const [showConsultationSuccessPopup, setShowConsultationSuccessPopup] = useState(false);
      
      const [showPopup, setShowPopup] = useState(false);
      const toggleQuotePopup = () => {
        if (!showQuotePopup) {
          setStatusMessage(""); // ✅ Clear status message only when opening
        }
        setShowQuotePopup(!showQuotePopup);
      };
      
      const toggleConsultationPopup = () => {
        if (!showConsultationPopup) {
          setConsultationStatusMessage(""); // ✅ Clear status message only when opening
        }
        setShowConsultationPopup(!showConsultationPopup);
      };
    
  // Handle quote form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage('Sending...');
  
    try {
      const response = await fetch("http://localhost:5000/quote", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        setStatusMessage('Quote request sent successfully!');
        setShowQuotePopup(false); // Close the form
        setShowPopup(true); // Show success popup
  
        // Reset the form after successful submission
        setFormData({
          name: "",
          email: "",
          phone: "",
          serviceType: "",
          customService: "",
          message: "",
          budget: "",
          customBudget: "",
          deadline: "",
        });
  
        // Hide success message after 2 seconds
        setTimeout(() => {
          setShowPopup(false);
        }, 2000);
        
      } else {
        const data = await response.json();
        setStatusMessage(data.error || 'Failed to send request. Please try again.');
      }
    } catch (error) {
      setStatusMessage('Error sending request. Please try again later.');
    }
  };
  
  
  // Handle consultation form submission
  const handleConsultationSubmit = async (e) => {
    e.preventDefault();
    setConsultationStatusMessage('Sending...');
  
    try {
      const response = await fetch("http://localhost:5000/consultation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(consultationData),
      });
  
      if (response.ok) {
        setConsultationStatusMessage('Consultation request sent successfully!');
        setShowConsultationPopup(false); // Close the consultation popup
        setShowConsultationSuccessPopup(true); // Show success popup
  
        // Reset the consultation form after successful submission
        setConsultationData({
          name: '',
          email: '',
          phone: '',
          company: '',
          website: '',
          serviceType: '',
          customService: '',
          projectDescription: '',
          problemStatement: '',
          existingSystem: '',
          communicationMethod: '',
          preferredDate: '',
          preferredTime: '',
          referralSource: '',
          additionalInfo: '',
        });
  // Open form & reset status message
  
  
        // Hide success popup after 2 seconds
        setTimeout(() => {
          setShowConsultationSuccessPopup(false);
        }, 2000);
  
      } else {
        const data = await response.json();
        setConsultationStatusMessage(data.error || 'Failed to send request. Please try again.');
      }
    } catch (error) {
      console.error("Consultation request error:", error);
      setConsultationStatusMessage('Error sending request. Please try again later.');
    }
  };
      
      // Handle input change for quote form
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      // Handle input change for consultation form
      const handleConsultationInputChange = (e) => {
        const { name, value } = e.target;
        setConsultationData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
  return (
   
   <section className={`cta-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
         <div className="cta-content">
           <h2>🚀 Let’s Build Your Digital Success Story!</h2>
           <p>
             Transform your business with cutting-edge web design, SEO, and cybersecurity solutions.
           </p>
   
           {/* Benefits */}
           <div className="cta-benefits">
             <div className="cta-benefit-card">
               <BiRocket size={28} className="cta-icon" />
               <span>Modern & Responsive</span>
             </div>
             <div className="cta-benefit-card">
               <BiSearchAlt size={28} className="cta-icon" />
               <span>SEO-Optimized</span>
             </div>
             <div className="cta-benefit-card">
               <BiShield size={28} className="cta-icon" />
               <span>Secure & Scalable</span>
             </div>
           </div>
   
    
           {/* Contact Info */}
           <div className="cta-contact">
           <div className="cta-contact-item">
     <a href="tel:+254791865638">
       <FaPhoneAlt size={18} className="cta-contact-icon" />
     </a>
     <a href="https://wa.me/254791865638" target="_blank" rel="noopener noreferrer">
       <FaWhatsapp size={20} className="cta-contact-icon whatsapp" />
     </a>
     <strong>+254 7918 656 38</strong>
   </div>
   
         <div className="cta-contact-item">
           <FaEnvelope size={18} className="cta-contact-icon" />
           <strong>info@astrasighttech.com</strong>
         </div>
       </div>
         </div>
          {/* Quote Popup */}
{showQuotePopup && (
  <div className={`popup-overlay ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className="popup-wrapper">
      <div className="popup-box">
        {/* Close Button */}
        <button className="popup-close" type="button" onClick={toggleQuotePopup}>✖</button>

        {/* Title */}
        <h3 className="title">Get a Free Quote</h3>
        <p className="subtitle">Provide some details about your project, and we'll send you a free quote.</p>

        {/* Form */}
        <form onSubmit={handleFormSubmit}>
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleInputChange} required />
          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleInputChange} required />
          <input type="tel" name="phone" placeholder="Your Phone" value={formData.phone} onChange={handleInputChange} required />

          <select name="serviceType" value={formData.serviceType} onChange={handleInputChange} required>
            <option value="">Select Service Type</option>
            <option value="web-design">Web Design</option>
            <option value="ecommerce">E-commerce Website</option>
            <option value="seo-marketing">SEO & Digital Marketing</option>
            <option value="graphic-design">Graphic Design</option>
            <option value="software-dev">Custom Software Development</option>
            <option value="cybersecurity">Cybersecurity Services</option>
            <option value="other">Other</option>
          </select>

          {formData.serviceType === "other" && (
            <input type="text" name="customService" placeholder="Specify your service" value={formData.customService} onChange={handleInputChange} />
          )}

          <textarea name="message" placeholder="Describe your project" value={formData.message} onChange={handleInputChange} required />

          <select name="budget" value={formData.budget} onChange={handleInputChange} required>
            <option value="">Select Your Budget</option>
            <option value="20000-50000">Ksh 20,000 - 50,000</option>
            <option value="50000-100000">Ksh 50,000 - 100,000</option>
            <option value="100000+">Ksh 100,000+</option>
            <option value="custom">Custom Budget</option>
          </select>

          {formData.budget === "custom" && (
            <input type="text" name="customBudget" placeholder="Enter your budget" value={formData.customBudget} onChange={handleInputChange} />
          )}

          <label>Preferred Completion Date:</label>
          <input type="date" name="deadline" value={formData.deadline} onChange={handleInputChange} required />

          {/* Submit Button */}
          <button className="popup-submit" type="submit">Request Quote</button>

          {/* Status Message (for errors) */}
          {statusMessage && <p className="popup-status">{statusMessage}</p>}
        </form>
      </div>
    </div>
  </div>
)}

{/* Success Popup (appears after form is submitted) */}
{showPopup && (
  <div style={{
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    background: 'white', padding: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '8px',
  }}>
    <p>{statusMessage}</p>
  </div>
)}


{/* Consultation Popup */}
{showConsultationPopup && (
  <div className={`popup-overlay ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className="popup-wrapper">
      <div className="popup-box">
        {/* Close Button */}
        <button className="popup-close" onClick={toggleConsultationPopup}>✖</button>

        {/* Form */}
        <form onSubmit={handleConsultationSubmit}>
          <h3 className="title">Book a Consultation</h3>
          <p className="subtitle">This form helps us understand your needs before offering services.</p>

          <div className="form-row">
            <input type="text" name="name" placeholder="Full Name" value={consultationData.name} onChange={handleConsultationInputChange} required />
            <input type="email" name="email" placeholder="Email Address" value={consultationData.email} onChange={handleConsultationInputChange} required />
          </div>

          <div className="form-row">
            <input type="tel" name="phone" placeholder="Phone Number" value={consultationData.phone} onChange={handleConsultationInputChange} required />
            <input type="text" name="company" placeholder="Company/Business Name (Optional)" value={consultationData.company} onChange={handleConsultationInputChange} />
          </div>

          <div className="form-row">
            <input type="text" name="website" placeholder="Business Website (if any)" value={consultationData.website} onChange={handleConsultationInputChange} />
            <select name="serviceType" value={consultationData.serviceType} onChange={handleConsultationInputChange} required>
              <option value="">Select a Service</option>
              <option value="Web Design">Web Design</option>
              <option value="Marketing">Marketing</option>
              <option value="Graphic Design">Graphic Design</option>
              <option value="SEO">SEO</option>
              <option value="Software Development">Software Development</option>
              <option value="Cybersecurity">Cybersecurity</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {consultationData.serviceType === "Other" && (
            <input className="full-width" type="text" name="customService" placeholder="Please specify the service" value={consultationData.customService} onChange={handleConsultationInputChange} required />
          )}

          <textarea name="projectDescription" placeholder="Describe Your Project" value={consultationData.projectDescription} onChange={handleConsultationInputChange} required />

          <textarea name="problemStatement" placeholder="What Problem Are You Trying to Solve?" value={consultationData.problemStatement} onChange={handleConsultationInputChange} required />

          <div className="form-row">
            <select name="existingSystem" value={consultationData.existingSystem} onChange={handleConsultationInputChange} required>
              <option value="">Do you have an existing system or website?</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>

            <select name="communicationMethod" value={consultationData.communicationMethod} onChange={handleConsultationInputChange} required>
              <option value="">Preferred Communication Method</option>
              <option value="Email">Email</option>
              <option value="Call">Call</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-row">
            <input type="date" name="preferredDate" value={consultationData.preferredDate} onChange={handleConsultationInputChange} required />
            <input type="time" name="preferredTime" value={consultationData.preferredTime} onChange={handleConsultationInputChange} required />
          </div>

          <div className="form-row">
            <select name="referralSource" value={consultationData.referralSource} onChange={handleConsultationInputChange} required>
              <option value="">How did you hear about us?</option>
              <option value="Referral">Referral</option>
              <option value="Social Media">Social Media</option>
              <option value="Google">Google</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <textarea className="full-width" name="additionalInfo" placeholder="Any Additional Information?" value={consultationData.additionalInfo} onChange={handleConsultationInputChange} />

          {/* Submit Button */}
          <button className="popup-submit" type="submit">Submit Consultation Request</button>

          {/* Status Message (for errors) */}
          {consultationStatusMessage && <p className="popup-status">{consultationStatusMessage}</p>}
        </form>
      </div>
    </div>
  </div>
)}

{/* Success Popup (Appears After Form Submission) */}
{showConsultationSuccessPopup && (
 
    <p>{consultationStatusMessage}</p>

)}
       </section>
  );
};

export default CTAPage;
